import React from 'react'
import Icon from 'material-ui/Icon'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'

const Context = (props) => {

  const {
    columns,
    toggleColumns,
    translate
  } = props

  return (
    <div>
      <Typography type="title">
        {translate("context_header_choose_column")}
      </Typography>
      <Typography>
        {translate("context_subheader_add_remove")}
      </Typography>
      <List dense>
        {
          columns.map((column, index) => {
            return column.id === 'id' || !column.display ? (null) : (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => {
                    if (!column.toggle)
                      return
                    column.show = !column.show
                    toggleColumns(column)
                  }}>
                  <ListItemIcon>
                    {
                      (column.show) ? (
                        <Icon>remove</Icon>
                      ) : (
                          <Icon>add</Icon>
                        )
                    }
                  </ListItemIcon>
                  <ListItemText primary={column.Header} />
                </ListItem>
                <Divider />
              </div>
            )
          })
        }
      </List>
    </div>
  )
}

export default withStyles(styles)(Context)



// WEBPACK FOOTER //
// ./src/components/deviceupdaterepositories/context/index.js